import { useState } from "react";
import { Skull, Wrench } from "lucide-react";
import { useSettings, assetUrl } from "../settings";

export const Logo = ({ className = "h-10 w-10" }) => {
  const { settings } = useSettings();
  const [failed, setFailed] = useState(false);
  const custom = !!settings.logo_url;
  const src = custom ? assetUrl(settings.logo_url) : "/assets/logo.png";
  if (!failed) {
    return (
      <img
        src={src}
        alt={`${settings.company_name} logo`}
        data-testid="brand-logo"
        onError={() => setFailed(true)}
        className={custom ? `${className} object-contain` : `${className} rounded-full border border-white/15 object-cover`}
      />
    );
  }
  return (
    <div data-testid="brand-logo-fallback" className={`relative ${className}`}>
      <Wrench className="absolute inset-0 m-auto h-full w-full -rotate-45 text-turquoise" strokeWidth={1.25} />
      <Wrench className="absolute inset-0 m-auto h-full w-full rotate-45 text-turquoise" strokeWidth={1.25} />
      <Skull className="absolute inset-0 m-auto h-3/5 w-3/5 text-volt" strokeWidth={1.5} />
    </div>
  );
};
